import Client from "./base/client";

export class AddressInfo {
  private client: Client;

  private host = window.location.origin;

  constructor(client: Client) {
    this.client = client;
  }

  getAddressByPostcode = <T extends object>({
    postcode,
  }: {
    postcode: string;
  }): Promise<T> => {
    const params = new URLSearchParams({ postcode });
    return this.client.post(
      `${this.host}/WebRequests/postcodes/fetch.php`,
      params
    );
  };
}
